import * as Yup from "yup";
import checkout from "./form6";

const {
  formField6: {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    project,
    city,
    district,
    commune
  },
} = checkout;

const validation6 = Yup.object().shape({
  [endow.name]: Yup.string().required(endow.errorMsg),
  [departmentLevel.name]: Yup.string().required(departmentLevel.errorMsg),
  [subordinateToTheDepartment.name]: Yup.string().required(subordinateToTheDepartment.errorMsg),
  [project.name]: Yup.string().required(project.errorMsg),
  [city.name]: Yup.string().required(city.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [commune.name]: Yup.string().required(commune.errorMsg),
});

export default validation6;
